"use client"

import { ErrorBoundary } from "@sentry/nextjs"
import type { ReactNode } from "react"
import MarketingHeading from "../common/MarketingHeading"
import { MasonryAPIViewer } from "./masonry/MasonryAPIViewer"
import { MasonryBigQueryViewer } from "./masonry/MasonryBigQueryViewer"
import { MasonryChartWidget } from "./masonry/MasonryChartWidget"
import { MasonryFinancialStatement } from "./masonry/MasonryFinancialStatement"
import { MasonryLeaderboard } from "./masonry/MasonryLeaderboard"
import { MasonryQueryEditor } from "./masonry/MasonryQueryEditor"
import { MasonrySheetsWidget } from "./masonry/MasonrySheetsWidget"
import { MasonryTreeMap } from "./masonry/MasonryTreeMap"

// Grid cell of one widget. Defaults to a third of the row on md and lg
const Cell = ({
  className = "md:col-span-2 lg:col-span-1",
  children,
}: {
  className?: string
  children: ReactNode
}) => (
  <div className={className}>
    <ErrorBoundary>{children}</ErrorBoundary>
  </div>
)

function ProductShowcaseMasonry() {
  return (
    <div className="w-full overflow-hidden py-20">
      <div className="max-w-[1240px] mx-auto mb-12">
        <MarketingHeading
          level={2}
          className="text-center text-[32px] leading-[0.9em] lg:text-[40px] md:max-w-[550px] mx-auto"
        >
          Onchain fundamentals
          <br />
          you can understand
        </MarketingHeading>
      </div>

      <div className="relative w-full">
        {/* One grid for all breakpoints, so each widget is in the HTML once */}
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-6 lg:grid-cols-3 gap-6">
          <Cell className="md:col-span-3 lg:col-span-2">
            <MasonryChartWidget />
          </Cell>
          <Cell className="md:col-span-3 lg:col-span-1">
            <MasonryLeaderboard />
          </Cell>
          <Cell>
            <MasonryTreeMap />
          </Cell>
          <Cell>
            <MasonryFinancialStatement />
          </Cell>
          <Cell>
            <MasonryQueryEditor />
          </Cell>
          <Cell>
            <MasonrySheetsWidget />
          </Cell>
          <Cell>
            <MasonryAPIViewer />
          </Cell>
          <Cell>
            <MasonryBigQueryViewer />
          </Cell>
        </div>
      </div>
    </div>
  )
}

export default ProductShowcaseMasonry
